var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2932 30.1327C29.8359 30.6442 29.1135 30.8245 28.4701 30.5865L15.5701 25.7993L2.6713 30.5853C2.0585 30.8115 1.37138 30.6596 0.912931 30.2011L0.848105 30.1315C0.624911 29.8818 0.482048 29.5705 0.438509 29.2384C0.394971 28.9062 0.452423 28.5686 0.603015 28.2695L14.0816 1.6033C14.3657 1.04349 14.942 0.68884 15.5701 0.687603C16.1982 0.686366 16.7698 1.04349 17.0586 1.6033L30.5372 28.2719C30.6888 28.5705 30.7466 28.908 30.7031 29.2401C30.6596 29.5721 30.5167 29.8833 30.2932 30.1327Z",
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/NavigationIcon.c57c2a03e350a73672cdfe08c1675799.svg";
export { ForwardRef as ReactComponent };